module.exports = __webpack_public_path__ + "0f5ecd4c02213b058c52b19a729b2308.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansextrabold.woff2
// module id = 678
// module chunks = 57